<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "curriculums",
  data() {
    return {};
  },
  created() {}
};
</script>
